import { useState, useEffect, useCallback } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export function useResource(path) {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [q, setQ] = useState("");
    const [summary, setSummary] = useState(null);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const { data } = await api.get(path, { params: q ? { q } : {} });
            setItems(data.items || []);
            setSummary(data.summary || null);
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setLoading(false);
        }
    }, [path, q]);

    useEffect(() => {
        const t = setTimeout(load, 200);
        return () => clearTimeout(t);
    }, [load]);

    const create = async (payload) => {
        try {
            const { data } = await api.post(path, payload);
            toast.success("Created");
            await load();
            return { ok: true, item: data.item };
        } catch (err) {
            return { ok: false, error: formatApiError(err) };
        }
    };

    const update = async (id, payload) => {
        try {
            await api.patch(`${path}/${id}`, payload);
            toast.success("Saved");
            await load();
            return { ok: true };
        } catch (err) {
            return { ok: false, error: formatApiError(err) };
        }
    };

    const remove = async (id) => {
        try {
            await api.delete(`${path}/${id}`);
            toast.success("Deleted");
            await load();
        } catch (err) {
            toast.error(formatApiError(err));
        }
    };

    return { items, summary, loading, q, setQ, load, create, update, remove };
}
